<template>
  <div class="of-box demandoperation">
    <div
      ref="tableBox"
      class="of-container is-vertical base-page-box"
    >
      <div class="of-aside  base-search-box">
        <div class="of-filter clearfix">
          <vxe-toolbar
            ref="xToolbar1"
            custom
          >
            <template #buttons>
              <!-- <el-button
                v-access:export
                type="primary"
                size="small"
                icon="fa fa-cloud-download"
                :loading="exportLoading"
                @click="Export()"
              >导出</el-button> -->
            </template>
            <template #tools>
              <el-popover
                ref="popoverDom"
                placement="bottom-start"
                width="320"
                popper-class="el_popover_class"
                trigger="click"
              >
                <div>
                  <div>
                    <el-form
                      label-width="80px"
                      :model="pageQuery"
                      class="search-form"
                    >

                      <el-form-item
                        label="板块"
                        v-show="false"
                        class="search-form-item"
                      >
                        <el-select
                          v-model="pageQuery.PlateName"
                          @change=" pageQuery.ProjectId = ''
                        pageQuery.ResidenceId = ''
                        pageQuery.RegionId = ''"
                          clearable
                          size="small"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in PlateTypeOpts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        label="项目"
                        class="search-form-item"
                      >
                        <el-select
                          v-model="pageQuery.ProjectId"
                          @change="pageQuery.ResidenceId = ''
                        pageQuery.RegionId = ''"
                          clearable
                          filterable
                          placeholder="请选择"
                          size="small"
                        >
                          <el-option
                            v-for="item in ProjectOpts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <!-- <el-form-item
                         label="区域"
                         class="search-form-item"
                       >
                         <el-select
                           v-model="pageQuery.RegionId"
                           placeholder="请选择"
                           clearable
                           size="small"
                         >
                           <el-option
                             v-for="item in RegionOpts"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id"
                           >
                           </el-option>
                         </el-select>
                       </el-form-item> -->
                      <el-form-item
                        label="驻地"
                        class="search-form-item"
                      >
                        <el-select
                          v-model="pageQuery.ResidenceIds"
                          multiple
                          filterable
                          placeholder="请选择"
                          size="small"
                          clearable
                        >
                          <el-option
                            label="请选择"
                            value=""
                          ></el-option>
                          <el-option
                            v-for="item in ResidenceOpts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item
                        label="业务"
                        class="search-form-item"
                      >
                        <el-select
                          v-model="pageQuery.ServiceId"
                          size="small"
                          filterable
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in ServiceOpts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        label="调度计划"
                        class="search-form-item"
                      >
                        <selectDropdownPage
                          :listData="dispatchList"
                          :tableColumn="dispatchTableColumn"
                          :value="dispatchTitle"
                          :placeholder="`关键字-20211101项目业务类型`"
                          size="small"
                          @search="searchDispatchTitle"
                          @select="selectDispatchTitle"
                          ref="comDropDown"
                        >
                        </selectDropdownPage>
                      </el-form-item>
                      <el-form-item
                        label="计划日期"
                        class="search-form-item"
                      >
                        <el-date-picker
                          placeholder="请选择"
                          v-model="DispatchDate"
                          style="width:auto"
                          type="datetimerange"
                          size="small"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :default-time="['00:00:00', '23:59:59']"
                          @change="dateChange"
                        ></el-date-picker>
                      </el-form-item>
                      <el-form-item
                        label="关键字"
                        class="search-form-item"
                      >
                        <el-input
                          v-model="pageQuery.fastSearchKeyWord"
                          placeholder="设备号码 / 驾驶员"
                          size="small"
                          clearable
                          prefix-icon="fa fa-search"
                        ></el-input>
                      </el-form-item>
                      <div
                        class="btns"
                        style="text-align: left;padding-top: 5px;"
                      >
                        <el-button
                          type="primary"
                          size="small"
                          @click="search"
                        >查 询</el-button>
                        <el-button
                          type="primary"
                          size="small"
                          @click="resetsSearch"
                        >重 置</el-button>
                      </div>
                    </el-form>

                  </div>
                </div>
                <el-button
                  size="small"
                  style="margin-left:10px;"
                  slot="reference"
                  @click="advSearch = (advSearch ? 0 : 1); initPageBoxHeight()"
                  icon="el-icon-search"
                >
                  高级搜索</el-button>
              </el-popover>
              <!-- <el-button
                type="primary"
                size="small"
                style="margin-left:10px;"
                @click="advSearch=(advSearch?0:1);initPageBoxHeight()"
              >高级搜索</el-button> -->
            </template>
          </vxe-toolbar>
        </div>

      </div>

      <div class="of-main">
        <div class="datals">
          <div v-loading="loading">
            <vxe-table
              :data="tableDatas"
              size="small"
              :height="boxHeight"
              resizable
              stripe
              align="center"
              border
              :tooltip-config="{ showAll: true, theme: 'light', enterable: true }"
              ref="xTable1"
              style="width: 100%"
            >
              <vxe-table-column
                v-for="(item, index) in Type == 'Person' ? tableCols : tableVehicleCols"
                :key="index"
                hight:80px
                show-overflow="tooltip"
                :field="item.field"
                :title="item.title"
                :width="item.width"
                header-align="left"
                :align="item.align"
              >
              </vxe-table-column>
              <vxe-table-column
                hight:80px
                show-overflow="tooltip"
                title="操作"
                width="150px"
                header-align="left"
              >
                <template slot-scope="scope">
                  <el-button
                    class="table-ctrlbtn"
                    type="text"
                    size="small"
                    icon="fa fa-search"
                    @click="checkView(scope.row)"
                  >行车日志</el-button>
                </template>
              </vxe-table-column>
            </vxe-table>

          </div>
        </div>
      </div>
      <div class="of-aside">
        <my-pagination
          :total="total"
          :pageSize="pageQuery.pageSize"
          :pageIndex="pageQuery.pageIndex"
          @change="pageChange"
        ></my-pagination>
      </div>
    </div>
    <my-drawer
      :visible="showCheckView"
      :title="'车辆三检和行车日志信息'"
      size="70%"
    >
      <print-detail
        slot="content"
        v-if="showCheckView"
        ref="examFormPage"
        :formData="checkViewData"
        :reportId="reportId"
      ></print-detail>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <dPDFBtn
          v-if="showCheckView"
          :title="`${checkViewData.NickName}行车日志`"
          el="print-detail-page"
          template="三检模板"
        ></dPDFBtn>
        <el-button
          size="small"
          @click="showCheckView = false"
        >关 闭</el-button>
      </span>
    </my-drawer>
  </div>
</template>

<script>
import { getBaseSearchOptsHasIsolation as getBaseSearchOpts } from '@/modules/report/api/baseSearch'
import MyPagination from "@/components/pagination"
import { searchTitle, employeeWaybilReport, exportEmployeeWaybillReport, vehicleWaybillReport, exportVehicleWaybillReport } from '@/modules/report/api/timp.js'
import selectDropdownPage from "@/modules/report/components/selectDropdown"
import moment from 'moment'
import printDetail from '@/modules/report/pages/timp/personnelOperation/checkPrintView_bak'
import MyDrawer from '@/components/drawer'
import dPDFBtn from "@/modules/base/components/downPdfBtn.vue"
export default {
  name: 'personnelOperation',
  components: {
    MyPagination,
    selectDropdownPage,
    printDetail,
    MyDrawer,
    dPDFBtn
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => {
        return {
          "ChangeType": '',
          "projectId": ''
        }
      }
    },
  },
  data () {
    return {
      showCheckView: false,
      checkViewData: null,
      baseInfo: null,
      tableDatas: [],
      loading: true,
      searchLoading: false,
      exportLoading: false,
      DispatchDate: [moment().startOf('day').format("YYYY-MM-01 HH:mm:ss"), moment().endOf('month').format("YYYY-MM-DD HH:mm:ss")],
      bar: '',
      Type: this.params.ChangeType ? this.params.ChangeType : 'Person',
      pageQuery: {
        pageSize: 50,
        pageIndex: 1,
        sortOrder: 'desc',
        sortField: 'NickName,DispatchDate',
        fastSearchFields: 'NickName',
        fastSearchKeyWord: '',
        PlateName: '',
        ResidenceId: '',
        ResidenceIds: [],
        DispatchId: '',
        ProjectId: this.params.projectId ? this.params.projectId : '',
        RegionId: '',
        Bar: '',
        ServiceId: '',
        Position: '驾驶员',
        StartTime: moment().startOf('day').format("YYYY-MM-01 HH:mm:ss"),
        EndTime: moment().endOf('month').format("YYYY-MM-DD HH:mm:ss"),
      },
      //人员
      tableCols: [
        { title: "日期", field: "DispatchDateStr", width: "100" },
        { title: "人员名称", field: "NickName", width: "100" },
        { title: "职位", field: "Position", width: "120" },
        { title: "班次", field: "SchedulingType", width: "100", align: 'right' },
        { title: "是否双驾", field: "DoubleDriver", width: "100" },
        { title: "出车检查时间", field: "WorkStartDate", width: "160" },
        { title: "收车检查时间", field: "WorkEndDate", width: "160" },
        { title: "出车趟次里程", field: "FirstWorkMileageStr", width: "200", align: 'right' },
        { title: "收车趟次里程", field: "LastWorkMileageStr", width: "200", align: 'right' },
        // { title: "暂停时长合计(小时)", field: "TimeOutTime", width: "160", align: 'right' },
        // { title: "中途休息时间合计(小时)", field: "RestTime", width: "160", align: 'right' },
        // { title: "驾驶时长合计(小时)", field: "DrivingTime", width: "160", align: 'right' },
        // { title: "最大驾驶时长(小时)", field: "MaxDrivingTime", width: "160", align: 'right' },
        // { title: "工作时长", field: "WorkingTime", width: "100", align: 'right' },
        // { title: "预计工作时长", field: "EstimateTime", width: "100", align: 'right' },
        // { title: "上一班睡眠时间", field: "LastSleepTime", width: "120", align: 'right' },
        // { title: "上一班休息间隔", field: "LastTrainRestTime", width: "120", align: 'right' },
        // { title: "实际装货量", field: "RealLoadingQty", width: "100", align: 'right' },
        // { title: "实际卸货量", field: "RealUnLoadingQty", width: "100", align: 'right' },
        // { title: "实际装货量(吨)", field: "RealLoadTon", width: "130", align: 'right' },
        // { title: "实际卸货量(吨)", field: "RealUnloadTon", width: "130", align: 'right' },
        // { title: "密度", field: "Density", width: "100" },
        // { title: "单位", field: "Unit", width: "100", align: 'right' },
        // { title: "预计装货时长合计", field: "EstimateLoadingTime", width: "160", align: 'right' },
        // { title: "预计路途时长合计", field: "EstimateDrivingTime", width: "160", align: 'right' },
        // { title: "预计卸货时长合计", field: "EstimateUnLoadingTime", width: "160", align: 'right' },
        // { title: "实际行驶里程", field: "DrivingMileage", width: "100", align: 'right' },
        // { title: "绕路运距", field: "DetourDistance", width: "100", align: 'right' },
        // { title: "提货点数量", field: "LoadingCount", width: "100", align: 'right' },
        // { title: "卸货点数量", field: "UnLoadingCount", width: "100", align: 'right' },
        { title: "当日关联设备", field: "TowVehicles", width: "100" },
        { title: "当日关联挂车", field: "TrailerVehicles", width: "100" },
        { title: "当日关联趟次", field: "TrainNumbers", width: "180", align: 'right' },
        { title: "当日关联押运员", field: "Employees", width: "120" },
        { title: "项目", field: "ProjectName", width: "180" },
        { title: "驻地", field: "OResidenceName", width: "150" },
        { title: "业务", field: "ServiceName", width: "150" },
      ],
      //车辆
      tableVehicleCols: [
        { title: "日期", field: "DispatchDateStr", width: "100" },
        { title: "设备号码", field: "VehicleNo", width: "100" },
        { title: "设备自编号", field: "VehicleSelfNumber", width: "100" },
        { title: "出车检查时间", field: "FirstDrivingDate", width: "160" },
        { title: "收车检查时间", field: "LastFDrivingDate", width: "160" },
        { title: "设备出车里程", field: "FirstDrivingMileage", width: "100", align: 'right' },
        { title: "设备收车里程", field: "LasstDrivingMileage", width: "100", align: 'right' },
        { title: "计划数量合计", field: "PlanQty", width: "100", align: 'right' },
        { title: "实际装货数量合计", field: "OilDepotQty", width: "130", align: 'right' },
        { title: "实际卸货数量合计", field: "OilStationQty", width: "130", align: 'right' },
        { title: "实际装货量(吨)", field: "RealLoadTon", width: "130", align: 'right' },
        { title: "实际卸货量(吨)", field: "RealUnloadTon", width: "130", align: 'right' },
        { title: "密度", field: "Density", width: "100", align: 'right' },
        { title: "计划单位", field: "Unit", width: "100", align: 'right' },
        { title: "实际行驶里程合计(公里)", field: "DrivingRealMileage", width: "160", align: 'right' },
        { title: "财务运距合计(公里)", field: "DistanceMileage", width: "140", align: 'right' },
        { title: "绕路运距", field: "DetourDistance", width: "100", align: 'right' },
        { title: "装货点数量合计", field: "LoadingPointCount", width: "120", align: 'right' },
        { title: "卸站点数量", field: "UnLoadingPointCount", width: "100", align: 'right' },
        { title: "货物种类品种数合计", field: "GoodNamesCount", width: "140", align: 'right' },
        { title: "货物规格品种数合计", field: "GoodsSpecificationsCount", width: "140", align: 'right' },
        { title: "执行趟次合计数", field: "TrainNumberCount", width: "120", align: 'right' },
        { title: "装货预计时长合计(小时)", field: "EstimateUnLoadingTime", width: "180", align: 'right' },
        { title: "路程预计时长合计(小时)", field: "EstimateDrivingTime", width: "180", align: 'right' },
        { title: "趟次中途休息预计时长合计(小时)", field: "EstimateRestTime", width: "220", align: 'right' },
        { title: "设备预计日运作时长(小时)", field: "EstimateWorkingTime", width: "200", align: 'right' },
        { title: "实际装货时长合计(小时)", field: "RealLoadingTime", width: "200", align: 'right' },
        { title: "实际路途时长合计(小时)", field: "RealDrivingTime", width: "200", align: 'right' },
        { title: "实际卸货时长合计(小时)", field: "RealUnLoadingTime", width: "200", align: 'right' },
        { title: "实际中途休息时长合计(小时)", field: "RealRestTime", width: "200", align: 'right' },
        { title: "实际停止时长合计(小时)", field: "RealTimeOutTime", width: "200", align: 'right' },
        { title: "设备实际日运作时长(小时)", field: "RealWorkingTime", width: "200", align: 'right' },
        { title: "关联挂车号", field: "TrailerVehicles", width: "100" },
        { title: "驾驶员", field: "Drivers", width: "100" },
        { title: "押运员", field: "Escorts", width: "100" },
        { title: "趟次", field: "Trains", width: "180", align: 'right' },
        { title: "项目", field: "ProjectName", width: "180" },
        { title: "驻地", field: "OResidenceName", width: "150" },
        { title: "业务", field: "ServiceName", width: "150" },
      ],
      advSearch: 0,
      boxHeight: 0,
      total: 0,
      // 调度计划搜索
      dispatchTitle: '',
      dispatchList: [], // 调度计划标题
      dispatchTableColumn: [
        { title: "时间", field: "DispatchDate", width: '300' },
        { title: "项目", field: "ProjectName", width: '300' },
        // { title: "区域", field: "RegionName", width: '100' },
        { title: "运营组/服务对象", field: "CustomerName", width: '100' },
      ],
      reportId: null,
    }
  },
  watch: {
    Type () {
      this.pageQuery.bar = ''
      this.bar = ''
      this.resetsSearch()
    }
  },

  computed: {
    PlateTypeOpts () {
      if (this.baseInfo)
        return this.baseInfo.PlateTypes.map(p => { return { id: p.Value, name: p.Value } })
      return []
    },
    ProjectOpts () {
      if (this.baseInfo) {
        if (this.pageQuery.PlateName)
          return this.baseInfo.AllProList.filter(p => { return !p.ParentId && p.Plate == this.pageQuery.PlateName }).map(p => { return { id: p.Id, name: p.Name } })
        return this.baseInfo.AllProList.filter(p => { return !p.ParentId }).map(p => { return { id: p.Id, name: p.Name } })
      }
      return []
    },
    RegionOpts () {
      if (this.baseInfo) {
        if (this.pageQuery.ProjectId)
          return this.baseInfo.AllProList.filter(p => { return p.ParentId && p.ParentId == this.pageQuery.ProjectId }).map(p => { return { id: p.Id, name: p.Name } })
      }
      return []
    },
    ResidenceOpts () {
      if (this.baseInfo) {
        if (this.pageQuery.ProjectId)
          return this.baseInfo.ResidenceList.filter((p) => {
            return p.ProjectId == this.pageQuery.ProjectId;
          }).map((p) => {
            return { id: p.Id, name: p.Name };
          });
      }
      return [];
    },
    ServiceOpts () {
      if (this.baseInfo) {
        return this.baseInfo.ServiceList.map(p => { return { id: p.Id, name: p.Name } })
      }
      return []
    }
  },
  mounted () {
    this.initPageBoxHeight()
    this.initOpt()
    this.loadData();
  },
  created () {
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.xTable1.connect(this.$refs.xToolbar1);

    });
  },
  methods: {
    initPageBoxHeight () {
      this.MixinBoxHeight(60, 'base-page-box', () => {
        let searchHeight = 70
        this.boxHeight = this.boxHeight - searchHeight
      })
    },
    initOpt () {
      getBaseSearchOpts().then(rep => {
        if (rep.data.Code == 0) {
          this.baseInfo = rep.data.Data
        }
      })
    },
    checkView (row) {
      this.showCheckView = true
      this.checkViewData = { EmployeeId: row.EmployeeId, DispatchId: row.DispatchId, NickName: row.NickName }
      this.reportId = row.Id
    },
    loadData () {
      this.loading = true
      if (this.Type == 'Person') {
        this.pageQuery.fastSearchFields = 'NickName'
        this.pageQuery.sortField = 'DispatchDate,NickName'
        if (this.pageQuery.ResidenceIds.length > 0) {
          this.pageQuery.ResidenceId = this.pageQuery.ResidenceIds.toString()
        }
        else if (this.pageQuery.ResidenceIds.length == 0) {
          this.pageQuery.ResidenceId = ''
        }
        employeeWaybilReport(this.pageQuery).then(res => {
          if (res.data.Code == 0) {
            this.total = res.data.Data.total
            this.tableDatas = res.data.Data.rows
            this.tableDatas.forEach(e => {
              e.TimeOutTime = e.TimeOutTime.toFixed(2)
              e.SleepTime = e.SleepTime.toFixed(2)
              e.RestTime = e.RestTime.toFixed(2)
              e.RealUnLoadingTime = e.RealUnLoadingTime.toFixed(2)
              e.RealUnLoadingQty = e.RealUnLoadingQty.toFixed(2)
              e.RealLoadingTime = e.RealLoadingTime.toFixed(2)
              e.RealLoadingQty = e.RealLoadingQty.toFixed(2)
              e.RealDrivingTime = e.RealDrivingTime.toFixed(2)
              e.MaxDrivingTime = e.MaxDrivingTime.toFixed(2)
              e.DrivingTime = e.DrivingTime.toFixed(2)
              e.WorkingTime = e.WorkingTime.toFixed(2)
              e.EstimateLoadingTime = e.EstimateLoadingTime.toFixed(2)
              e.EstimateDrivingTime = e.EstimateDrivingTime.toFixed(2)
              e.EstimateTime = e.EstimateTime.toFixed(2)
              e.EstimateUnLoadingTime = e.EstimateUnLoadingTime.toFixed(2)
              e.LastSleepTime = e.LastSleepTime.toFixed(2)
              e.LastTrainRestTime = e.LastTrainRestTime.toFixed(2)
              e.DrivingMileage = e.DrivingMileage.toFixed(2)
              e.DetourDistance = e.DetourDistance.toFixed(2)
            })
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      } else {
        this.pageQuery.fastSearchFields = 'VehicleNo'
        this.pageQuery.sortField = 'DispatchDate,VehicleNo'
        vehicleWaybillReport(this.pageQuery).then(res => {
          if (res.data.Code == 0) {
            this.total = res.data.Data.total
            this.tableDatas = res.data.Data.rows
            this.tableDatas.forEach(e => {
              e.EstimateDrivingTime = e.EstimateDrivingTime.toFixed(2)
              e.EstimateLoadingTime = e.EstimateLoadingTime.toFixed(2)
              e.EstimateRestTime = e.EstimateRestTime.toFixed(2)
              e.EstimateUnLoadingTime = e.EstimateUnLoadingTime.toFixed(2)
              e.EstimateWorkingTime = e.EstimateWorkingTime.toFixed(2)
              e.RealDrivingTime = e.RealDrivingTime.toFixed(2)
              e.RealLoadingTime = e.RealLoadingTime.toFixed(2)
              e.RealRestTime = e.RealRestTime.toFixed(2)
              e.RealTimeOutTime = e.RealTimeOutTime.toFixed(2)
              e.RealUnLoadingTime = e.RealUnLoadingTime.toFixed(2)
              e.RealWorkingTime = e.RealWorkingTime.toFixed(2)

            })
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }

    },
    search () {
      if (this.DispatchDate && this.DispatchDate.length > 0) {
        this.pageQuery.StartTime = this.datetime(this.DispatchDate[0])
        this.pageQuery.EndTime = this.datetime(this.DispatchDate[1])
      }
      this.advSearch = (this.advSearch ? 0 : 1)
      this.pageQuery.pageIndex = 1
      this.loadData()
      this.$refs.popoverDom.doClose()
    },
    resetsSearch () {
      this.pageQuery.ProjectId = this.params.projectId ? this.params.projectId : ''
      this.pageQuery.RegionId = ''
      this.pageQuery.ServiceId = ''
      this.pageQuery.PlateName = ''
      this.pageQuery.ResidenceId = ''
      this.pageQuery.ResidenceIds = []
      this.pageQuery.pageIndex = 1
      this.dispatchTitle = ''
      this.pageQuery.DispatchId = ''
      this.pageQuery.StartTime = moment().startOf('day').format("YYYY-MM-01 HH:mm:ss")
      this.pageQuery.EndTime = moment().endOf('month').format("YYYY-MM-DD HH:mm:ss")
      this.DispatchDate = [moment().startOf('day').format("YYYY-MM-01 HH:mm:ss"), moment().endOf('month').format("YYYY-MM-DD HH:mm:ss")]
      this.loadData()
    },
    pageChange (pindex, psize) {
      this.pageQuery.pageSize = psize
      this.pageQuery.pageIndex = pindex
      this.loadData()
    },
    Export () {

      this.$nextTick(() => {
        this.bar = this.$refs.xToolbar1._data.columns
        this.pageQuery.Bar = this.bar.filter(e => {
          return !e.visible;
        }).map(e => {
          return e.property
        });
        this.exportLoading = true
        if (this.Type == 'Person') {
          exportEmployeeWaybillReport(this.pageQuery).then(res => {
            if (res.data.Code == 0) {
              window.open(`/common/CommonTemplateDown/DownExportFile?ft=47&&id=${res.data.Data}`)
            } else {
              this.toast({ content: res.data.Message })
            }
            this.exportLoading = false
          }).catch(() => {
            this.exportLoading = false

          })
        } else {
          exportVehicleWaybillReport(this.pageQuery).then(res => {
            if (res.data.Code == 0) {
              window.open(`/common/CommonTemplateDown/DownExportFile?ft=46&&id=${res.data.Data}`)
            } else {
              this.toast({ content: res.data.Message })
            }
            this.exportLoading = false
          }).catch(() => {
            this.exportLoading = false

          })
        }
      });
    },
    dateChange (val) {
      if (val == null) {
        this.pageQuery.StartTime = null
        this.pageQuery.EndTime = null
      }
    },
    // 搜索调度计划
    initDispatch (title) {
      this.searchLoading = true
      searchTitle(title).then(res => {
        if (res.data.Code == 0) {
          this.dispatchList = res.data.Data
        }
      })
      this.searchLoading = false
    },
    searchDispatchTitle (title) {
      this.initDispatch(title)
    },
    selectDispatchTitle (select) {
      if (select) {
        this.dispatchTitle = `${select.CustomerName}(${this.datetime(select.DispatchDate, "YYYYMMDD")})`
        this.pageQuery.DispatchId = select.Id
      } else {
        this.dispatchTitle = ''
        this.pageQuery.DispatchId = ''
        this.initDispatch()
      }
    }

  },
}
</script>
